"use client";

import { useState, useEffect } from "react";

import { TwoLevelSelector } from "@/app/indicators/investigator/(components)/TwoLevelSelector";
import { IndicatorsContext } from "@/app/indicators/(context)/IndicatorsContext";
import { Spinner } from "@nextui-org/react";
import dynamic from "next/dynamic";
import { useRouter } from "next13-progressbar";

import { fetchAreas } from "@/app/indicators/investigator/actions/areasInvestigator";

// Importar dinámicamente los componentes
const PackedBubble = dynamic(() => import("@/app/charts/PackedBubble"), {
  ssr: false,
  loading: () => <Spinner size="large" label="Cargando gráfico" />,
});

export default function IndicatorsInvestigatorAreasPage() {
  const router = useRouter();
  const [series, setSeries] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);

  // Estas variables guardan los valores seleccionados
  const [level1Value, setLevelValue1] = useState(0);
  const [level2Value, setLevelValue2] = useState(-1);

  // Estas variables guardan los valores de los selectores
  const [dataSelector1, setDataSelector1] = useState([]);
  const [dataSelector2, setDataSelector2] = useState([]);

  const [loading, setLoading] = useState(true);

  function handlePointClick(name) {
    router.push(`/explore/documents?p=1&f=area_investigator_str:"${name}"`);
  }

  // Este efecto se ejecuta cuando se actualiza la variable data, que sólo va a pasar una vez
  useEffect(() => {
    setLoading(true);
    fetchAreas().then((resp) => {
      resp = resp.map(({ index, count, label }) => {
        return {
          index: +index,
          label,
          count,
        };
      });
      setData(resp);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (filteredData.length === 0) return;

    const groupedData = filteredData.reduce((acc, item) => {
      let groupedNumber = 0;
      let groupedLabel;

      groupedNumber = Math.floor(item.index / 1);

      // Crea la etiqueta de la decena
      groupedLabel = filteredData.find(
        (area) => area.index === groupedNumber,
      ).label;

      // Si la decena no existe en el acumulador, la inicializa con un array vacío
      if (!acc[groupedLabel]) {
        acc[groupedLabel] = [];
      }
      // Añade el item al array de su decena
      acc[groupedLabel].push({
        name: item.label,
        value: item.count,
        area_index: item.index,
      });

      return acc;
    }, {});

    const seriesAux = Object.entries(groupedData).map(([decena, data]) => ({
      name: `${decena}`,
      data,
    }));

    setSeries(seriesAux);
  }, [filteredData]);

  return (
    <IndicatorsContext.Provider
      value={{
        data,
        filteredData,
        setFilteredData,
        level1Value,
        level2Value,
        setLevelValue1,
        setLevelValue2,
        dataSelector1,
        dataSelector2,
        setDataSelector1,
        setDataSelector2,
        setLoading,
      }}
    >
      <div className="flex flex-col text-left">
        <TwoLevelSelector />
        {loading ? (
          <Spinner size="large" label="Cargando gráfico" className="mt-5" />
        ) : (
          <div className="flex flex-col md:flex-row gap-5 mt-10">
            <div
              className="w-full md:w-1/3 overflow-auto mb-5 "
              style={{ height: "75vh" }}
            >
              <div className="flex flex-col">
                <div className="flex flex-row border border-solid text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold py-3">
                  <div className="w-4/5 text-wrap">Área</div>
                  <div className="w-1/5 text-wrap"># pubs</div>
                </div>
              </div>
              <div className="flex flex-col">
                {filteredData.map((area) => (
                  <div
                    className={`flex flex-row border-t-0 border-l-0 border-r-0 whitespace-nowrap py-1 text-tiny`}
                    key={area.index}
                  >
                    <div className="w-4/5 text-wrap text-left">
                      {area.label}
                    </div>
                    <div className="w-1/5 text-wrap">{area.count}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full md:w-2/3">
              <PackedBubble
                series={series}
                handlePointClick={handlePointClick}
              />
            </div>
          </div>
        )}
      </div>
    </IndicatorsContext.Provider>
  );
}
